import React from "react";
import Popover from "@material-ui/core/Popover";
import Button from "@material-ui/core/Button";
import Select from "react-select";
import COLORS from "scss/colors.module.scss";
import MenuItem from "@material-ui/core/MenuItem";
import { OptionFormatter, colourStyles } from "./common/ColumnSelector";

export default function PickSortColumn(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const options = [];
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  if (props.sortedType) {
    return (
      <div>
        <Button onClick={handleClick}>{props.toggleComponent}</Button>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Select
            onChange={(selectedOption) => {
              props.sortType(props.sortedColumn, selectedOption.value);
            }}
            components={{
              DropdownIndicator: null,
              indicatorSeparator: null,
            }}
            options={[{ value: props.sortedType }]}
            menuIsOpen={true}
            formatOptionLabel={(data) => {
              return OptionFormatter(data.value);
            }}
            styles={colourStyles}
            isClearable={false}
            autoFocus={true}
            isSearchable={false}
            hideSelectedOptions={false}
            controlShouldRenderValue={false}
          />
        </Popover>
      </div>
    );
  } else {
    props.columns.map((column) => {
      if (column.value && !props.sortedColumns.includes(column.value)) {
        options.push(column);
      }
      return 0;
    });
  }
  return (
    <div>
      <Button onClick={handleClick}>{props.toggleComponent}</Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Select
          onChange={(selectedOption) => {
            props.sortColumn(
              selectedOption.value,
              true,
              props.replace,
              props.indexOfExistence,
              props.sortOrder
            );
          }}
          components={{
            DropdownIndicator: null,
            indicatorSeparator: null,
          }}
          options={options}
          menuIsOpen={true}
          formatOptionLabel={(data) => {
            return OptionFormatter(data.label ? data.label : data.value);
          }}
          styles={colourStyles}
          isClearable={false}
          autoFocus={true}
          isSearchable={true}
          hideSelectedOptions={false}
          controlShouldRenderValue={false}
        />
      </Popover>
    </div>
  );
}
